import { render, staticRenderFns } from "./onekeySignature.vue?vue&type=template&id=fb5d533a&scoped=true"
import script from "./onekeySignature.vue?vue&type=script&lang=js"
export * from "./onekeySignature.vue?vue&type=script&lang=js"
import style0 from "./onekeySignature.vue?vue&type=style&index=0&id=fb5d533a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5d533a",
  null
  
)

export default component.exports